import { combineReducers } from 'redux';

import modal from './modal';
import randomCode from './randomCode';
import validate from './validate';

export default combineReducers({
  modal,
  validate,
  randomCode,
});
